import { HomeDialog } from './home/HomeDialog';
import { shortcutGroups, type ShortcutRow, type ShortcutView } from './hotkeys';
import { t } from '../i18n/I18n';
import { useStore } from './useStore';

const GROUP_TITLES = { navigation: '#WebShortcutsNavigation', objects: '#WebShortcutsObjects', edit: '#WebShortcutsEdit' } as const;

function Group({ group, rows }: ReturnType<typeof shortcutGroups>[number]) {
  return <section className="shortcuts-group" aria-labelledby={`shortcuts-${group}`}>
    <h3 id={`shortcuts-${group}`}>{t(GROUP_TITLES[group])}</h3>
    <dl>{rows.map((row: ShortcutRow) => <div key={row.label} className="shortcuts-row">
      <dt>{t(row.label)}</dt>
      <dd>{'keys' in row ? row.keys.join(' / ') : t(row.text)}</dd>
    </div>)}</dl>
  </section>;
}

/** ⇧⌘/: every key of the editor, read from `HOTKEYS` and named for the platform (Figma «Modal · Keyboard shortcuts»). */
export function ShortcutsDialog({ onClose }: { onClose(): void }) {
  const view = useStore((s): ShortcutView => s.mode === 'plan' ? (s.planSurface === 'wall' ? 'wallPlan' : 'plan') : s.firstPerson ? 'walk' : 'orbit');
  const editable = useStore(s => s.edit !== 'none');
  const groups = shortcutGroups(undefined, view, editable);
  return <HomeDialog title={t('#WebKeyboardShortcuts')} onClose={onClose} className="shortcuts-dialog">
    <div className="shortcuts-columns">
      <div className="shortcuts-column">{groups.filter(group => group.group === 'navigation').map(group => <Group key={group.group} {...group} />)}</div>
      <div className="shortcuts-column">{groups.filter(group => group.group !== 'navigation').map(group => <Group key={group.group} {...group} />)}</div>
    </div>
  </HomeDialog>;
}
